<template>
<!-- // 资源概况 -->
    <div class="profile_wrap">
        <div class="profile_area" v-if="level != 3">
            <div class="area_select" @click="checkArea">
                <span>{{ selectArea }}</span>
                <img src="@/assets/resourcesManage/ic_jiantou_down2@2x.png" alt />
            </div>
        </div>
        <div class="profile_box">
            <div class="profile_title">资源数量统计</div>
            <div class="profile_nav">
                <div class="profile_nav_left">
                    <div class="profile_nav_title">总计(个)</div>
                    <div class="profile_nav_count" v-if="totalNum.sum">{{ totalNum.sum | numCount }}</div>
                </div>
                <div class="profile_nav_left line_left">
                    <div class="profile_nav_text">
                        <div class="profile_nav_text_left">五级</div>
                        <div class="profile_nav_text_right" v-if="totalNum.fifth">{{ totalNum.fifth | numCount }}</div>
                    </div>
                    <div class="profile_nav_text">
                        <div class="profile_nav_text_left">四级</div>
                        <div class="profile_nav_text_right" v-if="totalNum.fourth">{{ totalNum.fourth | numCount }}</div>
                    </div>
                    <div class="profile_nav_text">
                        <div class="profile_nav_text_left">三级</div>
                        <div class="profile_nav_text_right" v-if="totalNum.third">{{ totalNum.third | numCount }}</div>
                    </div>
                    <div class="profile_nav_text">
                        <div class="profile_nav_text_left">二级</div>
                        <div class="profile_nav_text_right" v-if="totalNum.second">{{ totalNum.second | numCount }}</div>
                    </div>
                    <div class="profile_nav_text">
                        <div class="profile_nav_text_left">一级</div>
                        <div class="profile_nav_text_right" v-if="totalNum.first">{{ totalNum.first | numCount }}</div>
                    </div>
                    <div class="profile_nav_text">
                        <div class="profile_nav_text_left">未评级</div>
                        <div class="profile_nav_text_right" v-if="totalNum.sum">{{ totalNum.noGrade | numCount }}</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="profile_box profile_box_bottom">
            <div class="profile_title profile_title_two">资源分布分析</div>
            <div class="profile_nav profile_item" v-for="(item, index) in listNum" :key="index">
                <div class="profile_nav_left" @click="goDirectories(item)">
                    <div class="profile_nav_title_img">
                        <div class="profile_nav_title_item">
                            <span>{{ item.name }}(个)</span>
                            <img src="@/assets/resourcesManage/ic_jt_ck@2x.png" alt />
                        </div>
                    </div>
                    <div class="profile_nav_count">{{ item.sum | numCount }}</div>
                </div>
                <div class="profile_nav_left line_left">
                    <div class="profile_nav_text">
                        <div class="profile_nav_text_left">五级</div>
                        <div class="profile_nav_text_right">{{ item.fifth | numCount }}</div>
                    </div>
                    <div class="profile_nav_text">
                        <div class="profile_nav_text_left">四级</div>
                        <div class="profile_nav_text_right">{{ item.fourth | numCount }}</div>
                    </div>
                    <div class="profile_nav_text">
                        <div class="profile_nav_text_left">三级</div>
                        <div class="profile_nav_text_right">{{ item.third | numCount }}</div>
                    </div>
                    <div class="profile_nav_text">
                        <div class="profile_nav_text_left">二级</div>
                        <div class="profile_nav_text_right">{{ item.second | numCount }}</div>
                    </div>
                    <div class="profile_nav_text">
                        <div class="profile_nav_text_left">一级</div>
                        <div class="profile_nav_text_right">{{ item.first | numCount }}</div>
                    </div>
                    <div class="profile_nav_text">
                        <div class="profile_nav_text_left">未评级</div>
                        <div class="profile_nav_text_right">{{ item.noGrade | numCount }}</div>
                    </div>
                </div>
            </div>
        </div>

        <common-picker ref="commonpicker" :typeList="cityList" :cols="cols" @getTypeValue="getCityValue"></common-picker>
    </div>
</template>

<script>
import api from '../../../../../service/modules/resourcesManage';
import commonPicker from '../../../../components/base/commonPickerTwo';
import { timeType1 } from '../../../../../utils/configJson';

export default {
    components: {
        commonPicker,
        timeType1
    },
    data () {
        return {
            selectArea: '',
            typeListCity: timeType1,
            cols: 2,
            totalNum: {},
            listNum: [],
            regionLevel: '',
            areaCode: '',
            regionId: '',
            cityList: timeType1,
            level: localStorage.getItem('level')
        }
    },
    created () {
        this.getDataList();
        this.getCityList();
    },
    methods: {
        async getDataList () {
            let params = {
                // regionLevel: this.regionLevel,
                // areaCode: this.areaCode
                regionId: this.regionId
            }
            let res = await api.getSituation(params);
            if (res.ret === 0) {
                let data = res.data;
                this.totalNum = data.total;
                this.listNum = data.all;
            }
        },
        checkArea () {
            this.$refs.commonpicker.showPicker();
        },

        getCityValue (val) {
           if (val && val.length === 2) {
               if (val[1].text === '全部') {
                   this.selectArea = val[0].text;
                   this.areaCode = val[0].value;
                   this.regionLevel = val[0].level;
                   this.regionId = val[0].id;
               } else {
                   this.selectArea = val[1].text;
                   this.areaCode = val[1].value;
                   this.regionLevel = val[1].level;
                   this.regionId = val[1].id;
               }
           } else if (val && val.length === 1) {
                this.selectArea = val[0].text;
                this.areaCode = val[0].value;
                this.regionLevel = val[0].level;
                this.regionId = val[0].id;
           }
           this.totalNum = {};
           this.listNum = [];
           this.getDataList();

        },
        goDirectories (e) {
            this.$router.push({
                path: '/resourcesManage/directories',
                query: {
                    areaCode: e.areaCode,
                    regionLevel: e.regionLevel,
                    regionId: e.id,
                    name: e.name,
                    level: this.$route.query.resourcesManageAreaLevel
                }
            })
        },
        async getCityList () {
            let res = await api.getRegions();
            if (res.ret === 0) {
                this.selectArea = res.data[0].fullName;
            }
            if (this.level == 1) {
                // this.cols = 2;
                let obj = {
                    text: '云南省',
                    value: '',
                    shortName: '云南省',
                    level: '',
                    children: [
                        {
                            text: '全部',
                            value: '',
                            shortName: '全部',
                            level: ''
                        }
                    ]
                }
                let arr = res.data[0].children.map(item => {
                    return {
                        text: item.fullName,
                        shortName: item.fullName,
                        value: item.areaCode,
                        level: item.regionLevel,
                        id: item.id,
                        pId: item.pId,
                        children: item.children.map(e => {
                            return {
                                text: e.fullName,
                                shortName: e.fullName,
                                value: e.areaCode,
                                level: e.regionLevel,
                                id: e.id,
                                pId: e.pId
                            }
                        })
                    }
                })
                for (var i = 0; i < arr.length; i++) {
                    if (arr[i].children) {
                        let cityChild = [{ text: '全部', value: '', shortName: '全部', level: '' }];
                        let newArr = arr[i].children.concat([]);
                        arr[i].children = cityChild.concat(newArr)
                    }
                }
                arr.unshift(obj);
                this.cityList = [];
                this.cityList.push(arr);
            } else if (this.level == 2) {
                let brr = res.data.map(item => {
                    return {
                        text: item.fullName,
                        shortName: item.fullName,
                        value: item.areaCode,
                        level: item.regionLevel,
                        id: item.id,
                        pId: item.pId,
                        children: item.children.map(e => {
                            return {
                                text: e.fullName,
                                shortName: e.fullName,
                                value: e.areaCode,
                                level: e.regionLevel,
                                id: e.id,
                                pId: e.pId
                            }
                        })
                    }
                })
                for (var i = 0; i < brr.length; i++) {
                    if (brr[i].children) {
                        let cityChild = [{ text: '全部', value: '', shortName: '全部', level: '' }];
                        let newArr = brr[i].children.concat([]);
                        brr[i].children = cityChild.concat(newArr)
                    }
                }
                this.cityList = [];
                this.cityList.push(brr);
            }
        }
    },
    filters: {
        numCount (item) {
            return (item + '').replace(/(?=(?!\b)(\d{3})+$)/g, ',');
        }
    }
}
</script>

<style lang="less" scoped>
.profile_wrap {
    padding: 0 12px;
    .profile_area {
        margin: 12px 0;
        color: #333;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .area_select {
            font-size: 20px;
            font-weight: bold;
            line-height: 20px;
            span {
                display: inline-block;
            }
            img{
                display: inline-block;
                margin-left: 4px;
                width: 6px;
                height: 4px;
                vertical-align: middle;
            }
        }
    }
    .profile_box_bottom {
        margin-bottom: 16px;
    }
    .profile_box {
        .profile_title {
            padding: 12px 0;
            color: #333;
            font-size: 20px;
            font-weight: bold;
        }
        .profile_title_two {
            padding-top: 24px;
        }
        .profile_item {
            margin-bottom: 12px;
        }
        .profile_nav {
            box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.04);
            border-radius: 3px;
            background: #FFFFFF;
            display: flex;
            justify-content: space-around;
            align-items: center;
            .profile_nav_left {
                width: 50%;
                padding: 16px 0;
                .profile_nav_title {
                    text-align: center;
                    color: #333;
                    font-size: 12px;
                    font-weight: 400;
                    margin-bottom: 8px;
                }
                .profile_nav_title_img {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    .profile_nav_title_item {
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        color: #333;
                        font-size: 12px;
                        font-weight: 400;
                        margin-bottom: 8px;
                        span {
                            display: inline-block;
                            margin-top: 1px;
                        }
                        img{
                            display: inline-block;
                            width: 12px;
                            height: 12px;
                            margin-left: 4px;
                            vertical-align: middle;
                        }
                    }
                }
                .profile_nav_count {
                    color: #36B374;
                    font-size: 32px;
                    font-weight: bold;
                    text-align: center;
                }
                .profile_nav_text {
                    display: flex;
                    margin: 8px 0;
                    color: #666;
                    font-size: 12px;
                    font-weight: 400;
                    .profile_nav_text_left {
                        margin-left: 30px;
                        width: 46px
                    }
                    .profile_nav_text_right {
                    }
                }
            }
        }
    }
    /deep/.distribution_wrap .md-popup-mask {
        background-color: rgba(37, 38, 45, 0.3);
    }
    /deep/.md-popup-mask {
      background-color: rgba(37,38,45,.3);
    }
    /deep/.van-overlay {
      background-color: rgba(37,38,45,.3);
    }
}
</style>
